import { render, staticRenderFns } from "./shortcodeCounter.vue?vue&type=template&id=5457516c&"
import script from "./shortcodeCounter.vue?vue&type=script&lang=js&"
export * from "./shortcodeCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports